import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, 
         FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // uses localStorage
import { combineReducers } from 'redux';
import authReducer from '../features/auth/authSlice';
import sessionReducer from '../features/auth/sessionSlice';
import tokenReducer from '../features/auth/tokenSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  session: sessionReducer,
  token: tokenReducer
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: [
    "token",
    "session"
  ],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
